export default __webpack_public_path__ + "static/media/Tunic of the Oxmal.16b8b74d.jpg";